import stringHelpers from "../../utilities/stringHelpers"
import { dateRange, areDatesEqual } from "../../utilities/dateUtilities"
export const DateRangePresetOption = ({ rangeType, label, fromDate, toDate, setDateRange }) => {
    const { firstDate, lastDate, displayString } = dateRange(rangeType)
    return (
        <button
            onClick={ () => setDateRange(firstDate, lastDate) }
            className={ `dropdown-item ${ !stringHelpers.isNullOrEmpty(rangeType) && (areDatesEqual(fromDate, firstDate) && areDatesEqual(toDate, lastDate)) && "active" }` }
        >
            <span>{label}</span> <span>{ displayString }</span>
        </button>
    )
}
